import { EtiquetaAutocompleteComponent } from '../../common/autocomplete/etiqueta-autocomplete';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CuentasService } from '../../../services/cuentas-service';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-new-etiqueta',
  templateUrl: './new-etiqueta.component.html',
  styleUrls: ['./new-etiqueta.component.scss']
})
export class NewEtiquetaComponent implements OnInit {

  @ViewChild(EtiquetaAutocompleteComponent) etiquetaAutocompleteComponent;  
  public cuenta;

  constructor(private cuentasService: CuentasService,
              public dialogRef: MdDialogRef<NewEtiquetaComponent>) { }

  ngOnInit() {

  }

  onSubmit(){
    const onSubmitSuccess = _ => this.dialogRef.close();
    const onSubmitFail = _ => {
      
    };

    if (this.etiquetaAutocompleteComponent.etiquetasStateControl.value &&
        !this.etiquetaAutocompleteComponent.selectedEtiquetas.length){
      this.cuentasService.createLabel(
        this.etiquetaAutocompleteComponent.etiquetasStateControl.value, 
        this.cuenta.Id)
        .subscribe(onSubmitSuccess, onSubmitFail);
    } else if (this.etiquetaAutocompleteComponent.selectedEtiquetas.length) {

      let etiquetas = this.cuenta.Etiquetas || [];

      etiquetas = [...etiquetas, ... this.etiquetaAutocompleteComponent.selectedEtiquetas.map(e => {
        return {Id: e.Id};
      })];

      this.cuentasService.updateCuenta({
        ...this.cuenta,
        ...{
          Etiquetas: etiquetas
        }
      }).subscribe(onSubmitSuccess, onSubmitFail);
    } else {
      this.dialogRef.close();
    }
  }    
  
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-etiqueta/new-etiqueta.component.ts